import { createAxiosInstance } from '@/lib/createAxiosInstance';

export const internalAxios = createAxiosInstance({
    baseURL: import.meta.env.VITE_API_INTERNAL_URL,
});

export const lotteShoppingAxios = createAxiosInstance({
    baseURL: import.meta.env.VITE_API_LOTTE_SHOPPING_URL,
});

export const lotteParkingAxios = createAxiosInstance({
    baseURL: import.meta.env.VITE_API_LOTTE_PARKING_URL,
});

export const cdnAxios = createAxiosInstance({
    baseURL: import.meta.env.VITE_AWS_CDN_URL,
    timeout: 10000
});
